import { createContext } from "react";

/**
 * @typedef ListItem
 * @property {string} imageURL
 * @property {number} referrals
 * @property {string} uuid
 * @property {string} name
 * @property {string} designation
 */

/**
 * @typedef AppState
 * @property {number} totalReferrals
 * @property {number} uniqueReferrals
 * @property {ListItem[]} list
 * @property {ListItem[]} topFiveList
 */
export const AppContext = createContext(/** @type {AppState} */ (null));
